/**
 * "My Map" pin statuses - the single source of truth shared by the
 * My-Map map layer, the detail-panel editor and the watchlist page.
 *
 * Keys MUST stay in sync with PIN_STATUSES in
 * web-app/backend/app/routes/watchlist.py. Colors are explicit hexes
 * (not Tailwind palette utilities) so the dark-theme palette remap can't
 * dim them on the map / chips.
 */
import type { TranslationKey } from "@/lib/i18n";

export type PinStatus =
  | "interested"
  | "seen"
  | "contacted"
  | "top_pick"
  | "rejected";

// Display order in the segmented control + legend (positive -> terminal).
export const PIN_STATUS_ORDER: PinStatus[] = [
  "interested",
  "seen",
  "contacted",
  "top_pick",
  "rejected",
];

export const STATUS_COLOR: Record<PinStatus, string> = {
  interested: "#16a34a", // green
  seen: "#0284c7", // blue
  contacted: "#7c3aed", // violet
  top_pick: "#f59e0b", // amber (the "maybe it's yours" standout)
  rejected: "#6b7280", // gray
};

// Color for a saved pin with no status yet (just hearted). Matches
// DEFAULT_POINT_COLOR on the listings map layer.
export const PIN_DEFAULT_COLOR = "#94a3b8"; // slate

export const STATUS_LABEL_KEY: Record<PinStatus, TranslationKey> = {
  interested: "pin.status.interested",
  seen: "pin.status.seen",
  contacted: "pin.status.contacted",
  top_pick: "pin.status.top_pick",
  rejected: "pin.status.rejected",
};

// A pin's private note - kept short on purpose (a quick reminder, not an
// essay): viewing time, who to call, what to negotiate.
export const NOTES_MAX_LEN = 300;
